module.exports = __webpack_public_path__ + "dacd4b5ec3283fb89a11acb588f77d78.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/circle_3.svg
// module id = 174
// module chunks = 0